import React from 'react';

import { SimpleTag } from '@atlaskit/tag';
import Tooltip from '@atlaskit/tooltip';

import { BugsSummaryTextStyled } from './ReportColumn.styled';

type Props = {
  bugsSummary: { newBugs: number };
};

export default function NewIssues({ bugsSummary }: Props): JSX.Element {
  const getContent = () => {
    const text = `${bugsSummary.newBugs} new`;

    if (bugsSummary.newBugs >= 5) {
      return <SimpleTag text={text} color='yellowLight' />;
    }

    return (
      <BugsSummaryTextStyled>{bugsSummary.newBugs} new</BugsSummaryTextStyled>
    );
  };

  return (
    <Tooltip
      key='newIssuesTooltip'
      content='Bugs reported in the last 14 days we mark as new.'
    >
      {getContent()}
    </Tooltip>
  );
}
